<template>
  <div>
    <el-select v-model="selectObj" class="title-bar" :width="searchWidth" filterable @change="selectObjType">
      <el-option v-for="item in objList" :key="(managetypeId == 'SMS') ? item.objtypeId : item.objCompanyId" :label="item.label" :value="(managetypeId == 'SMS') ? item.objtypeId : item.objCompanyId"/>
    </el-select>
    <w-search-field class="mr-b10" @search="onSearch"></w-search-field>
    <el-table class="setting" :data="filteredData" ref="ruleTable" @cell-click="onClickGridList" row-class-name="c-pointer" highlight-current-row>
      <!-- <el-table-column width="35">
        <template slot-scope="scope">
          <el-tooltip v-if="isUpState(scope.row.runningState)" class="item" effect="dark" :content="`${getDateToString(scope.row.runningState.checkDatetime, 'YYYY-MM-DD HH:mm:ss')}`" placement="top">
            <i  class="fas fa-circle text-mini state-normal"/>
          </el-tooltip>
          <i v-else class="fas fa-circle text-mini" style="color:#bbb"/>
        </template>
      </el-table-column> -->
      <el-table-column prop="label" show-overflow-tooltip/>
    </el-table>
  </div>
</template>

<script>
import GridMenuAPI from '@/api/settings/log/lms-grid-menu-setting';
import { getDateToString } from '@/utils/date';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import WSearchField from '@/components/form/SearchField';

export default {
  name: 'WLogGridMenu',
  components: {
    WSearchField,
  },
  data() {
    return {
      searchKeyword: null,
      selectObj: null,
      selectedNode: null,
      gridData: [],
      objList: [],
      search: '',
    };
  },
  props: {
    managetypeId: {
      type: String,
    },
    searchWidth: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    /**
     * 검색창에의 단어로 데이터를필터해 반환
     * @author leesy918
     * @return {[type]} [description]
     */
    filteredData() {
      if (isEmpty(this.searchKeyword)) {
        return this.gridData;
      }
      const keyword = this.searchKeyword.toLowerCase();
      return filter(this.gridData, (item) => item.label.toLowerCase().indexOf(keyword) > -1);
    },
  },
  methods: {
    getDateToString,
    selectObjType(item) {
      let params;
      if (this.managetypeId === 'SMS') {
        params = {
          managetypeId: this.managetypeId,
          objtypeId: item,
        };
      } else {
        params = {
          managetypeId: this.managetypeId,
          objCompanyId: item,
        };
      }
      GridMenuAPI.getSelectObjTypeMenu(params).then((response) => {
        if (response.data.success) {
          this.gridData = response.data.data;
          this.onClickGridList(this.gridData[0]);
          const selectedRow = this.gridData[0];
          this.$refs.ruleTable.setCurrentRow(selectedRow);
        }
      });
    },
    onSearch(value) {
      this.searchKeyword = value;
    },
    loadData() {
      GridMenuAPI.getLmsGridMenu({ managetypeId: this.managetypeId }).then((response) => {
        if (response.data.success) {
          this.objList = response.data.data;
          if (this.managetypeId === 'SMS') {
            this.selectObj = this.objList[0].objtypeId;
            this.selectObjType(this.objList[0].objtypeId);
          } else {
            this.selectObj = this.objList[0].objCompanyId;
            this.selectObjType(this.objList[0].objCompanyId);
          }
        }
      });
    },
    onClickGridList(item) {
      this.selectedNode = item;
      this.$emit('selectObjMenu', item);
    },
    getSelectNode() {
      return this.selectedNode;
    },
    isUpState(item) {
      if (isNil(item)) {
        return false;
      }
      return (item.stringValue === '1');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Components/LogGridMenu.vue